import { render, staticRenderFns } from "./ProportionChart.vue?vue&type=template&id=025e3d32&scoped=true&"
import script from "./ProportionChart.vue?vue&type=script&lang=js&"
export * from "./ProportionChart.vue?vue&type=script&lang=js&"
import style0 from "./ProportionChart.vue?vue&type=style&index=0&id=025e3d32&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025e3d32",
  null
  
)

export default component.exports